export const getDomainDefaultLanguage = (): 'en' | 'fr' => {
    const hostname = window.location.hostname;
    
    // Production domains
    if (hostname.includes('monaccolade.ca')) {
        return 'fr';
    }
    
    if (hostname.includes('myaccolade.ca')) {
        return 'en';
    }
    
    // Default to English for development
    return 'en';
};